import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { IvrApi } from "service/api/ivr.api";
import { QUERY_KEYS } from "service/constant/query-keys";

export const useGetListIvr = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.IVR_LIST, params],
    queryFn: async () => {
      const res = await IvrApi.getListIvr(params);
      return res.data;
    },
    ...options,
  });
};

export const useGetCountListIvr = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.IVR_LIST_COUNT, params],
    queryFn: async () => {
      const res = await IvrApi.getCountListIvr(params);
      return res.data.count;
    },
    ...options,
  });
};

export const useGetIvrDetail = (id, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.IVR_DETAIL, id],
    queryFn: async () => {
      const res = await IvrApi.getIvrDetail(id);
      return res.data;
    },
    ...options,
  });
};

export const useCreateIvr = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (payload) => {
      return IvrApi.createIvr(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.IVR_LIST] });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.IVR_LIST_COUNT],
      });
      enqueueSnackbar("Thêm ivr thành công", { variant: "success" });
    },
  });
};

export const useEditIvr = (id) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (payload) => {
      return IvrApi.editIvr(id, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.IVR_LIST] });
      enqueueSnackbar("Chỉnh sửa ivr thành công", { variant: "success" });
    },
  });
};

export const useDeleteIvr = (id) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  return useMutation({
    mutationFn: () => {
      return IvrApi.deleteIvr(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.IVR_LIST] });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.IVR_LIST_COUNT],
      });
      enqueueSnackbar("Xóa ivr thành công", { variant: "success" });
    },
  });
};

export const useInfiniteIvr = (params) => {
  return useInfiniteQuery({
    queryKey: [QUERY_KEYS.IVR_LIST_INFINITE, params],
    queryFn: async ({ pageParam = 1 }) => {
      const { data } = await IvrApi.getListIvr({
        filter: {
          order: "createdAt DESC",
          limit: 20,
          skip: (pageParam - 1) * 20,
          ...(params && { where: params }),
        },
      });
      return data;
    },
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      return (lastPageParam ?? 1) + 1;
    },
  });
};
